export default "__VITE_ASSET__B_Eufn3t__"